<template>
  <div class="ad-container">
    <template v-if="isSmallScreen">
      <iframe
        src="//rcm-na.amazon-adsystem.com/e/cm?o=1&p=288&l=ur1&category=amazonhomepage&f=ifr&linkID=eda7b5f6e4632d41272c5831dc2ca056&t=hopnami06-20&tracking_id=hopnami06-20"
        width="320"
        height="50"
        scrolling="no"
        border="0"
        marginwidth="0"
        style="border:none;"
        frameborder="0"
      ></iframe>
    </template>
    <template v-else>
      <iframe
        src="//rcm-na.amazon-adsystem.com/e/cm?o=1&p=13&l=ez&f=ifr&linkID=af333b62362ff01826f51e93fda8b4b6&t=hopnami06-20&tracking_id=hopnami06-20"
        width="468"
        height="60"
        scrolling="no"
        border="0"
        marginwidth="0"
        style="border:none;"
        frameborder="0"
      ></iframe>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: window.innerWidth || document.documentElement.offsetWidth,
      isSmallScreen: false
    };
  },
  beforeMount() {
    this.isSmallScreen = this.windowWidth < 720;
  },
  mounted() {
    console.log(this.windowWidth);
    console.log(this.isSmallScreen);

    window.onresize = () => {
      this.windowWidth =
        window.innerWidth || document.documentElement.offsetWidth;
    };
  },
  watch: {
    windowWidth() {
      this.isSmallScreen = this.windowWidth < 720;
    }
  }
};
</script>

<style lang="scss" scoped>
.ad-container {
  position: absolute;
  bottom: 60px;
  left: 0;
  right: 0;
  margin: auto;
  // max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
</style>
